import React, { FC } from 'react';
import { InfoButtonProps } from './types';
import { IconButton } from '../IconButton';
import { ButtonVariant, ButtonSize } from '../Button';
import { i18n } from '../../../i18n';

export const InfoButton: FC<InfoButtonProps> = ({
  ariaLabel,
  size = ButtonSize['2XS'],
  variant = ButtonVariant.GHOST,
  colorScheme = 'info',
  isRound = true,
  ...rest
}) => {
  return (
    <IconButton
      ariaLabel={ariaLabel ?? i18n.t('Info')}
      icon={{ iconName: 'info-circle', prefix: 'far' }}
      isRound={isRound}
      size={size}
      variant={variant}
      colorScheme={colorScheme}
      // Chakra's ghost variant is palette-blind, so the icon takes its palette's 600 step directly.
      color="colorPalette.600"
      {...rest}
    />
  );
};

InfoButton.displayName = 'InfoButton';
